import React from "react";
import { iframe, iframeTitle } from "./style.mod.scss";

const Iframe = ({ data }) => {
  let { iframeUrl } = data;

  return (
    <>
      <iframe className={iframe} src={iframeUrl} frameBorder={0} ></iframe>
      <h1 className={iframeTitle}>Iframe</h1>
    </>
  );
};

export default Iframe;
